export var BufferTargetType;
(function (BufferTargetType) {
    BufferTargetType[BufferTargetType["ARRAY_BUFFER"] = 1] = "ARRAY_BUFFER";
    BufferTargetType[BufferTargetType["ELEMENT_ARRAY_BUFFER"] = 2] = "ELEMENT_ARRAY_BUFFER";
    BufferTargetType[BufferTargetType["UNIFORM_BUFFER"] = 4] = "UNIFORM_BUFFER";
    BufferTargetType[BufferTargetType["COPY_READ_BUFFER"] = 8] = "COPY_READ_BUFFER";
    BufferTargetType[BufferTargetType["COPY_WRITE_BUFFER"] = 16] = "COPY_WRITE_BUFFER";
    BufferTargetType[BufferTargetType["TRANSFORM_FEEDBACK_BUFFER"] = 32] = "TRANSFORM_FEEDBACK_BUFFER";
})(BufferTargetType || (BufferTargetType = {}));
export var BufferUsage;
(function (BufferUsage) {
    BufferUsage[BufferUsage["Static"] = 0] = "Static";
    BufferUsage[BufferUsage["Dynamic"] = 1] = "Dynamic";
    BufferUsage[BufferUsage["Stream"] = 2] = "Stream";
})(BufferUsage || (BufferUsage = {}));
